import React from 'react';
import Text from 'components/base/Text';
import { Padding, Flex } from 'components/base/layout-components';
import language from 'common/language/en.lang';
import { Tooltip } from '@material-ui/core';
import Bullet from 'components/base/Bullet';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';

const {
  reauthorizeTooltipTitle,
  personalNotificationBulletTitleText,
  personalNotificationBulletContentText,
  slackCommandBulletContentText,
  slackCommandBulletTitleText,
  learnMoreText
} = language.Setting.Slack.reauthorize;

const tooltipContent = () => {
  return (
    <Flex>
      <Padding t='medium' b='small' r='small' l='small' width='24rem'>
        <Text weight={500} size='x-large'>
          {reauthorizeTooltipTitle()}
        </Text>
        <Flex mt='small' direction='column'>
          <Bullet backgroundColor='pigeonPost' width='0.6rem' height='0.6rem'>
            <Text size='large' weight={400} color='shark'>
              {personalNotificationBulletTitleText()}
              <br />
              <Text
                size='large'
                weight={400}
                lineHeight='2.4rem'
                color='shuttleGray'
              >
                {personalNotificationBulletContentText()}
              </Text>
            </Text>
          </Bullet>
          <Bullet
            mt='1.6rem'
            backgroundColor='pigeonPost'
            width='0.6rem'
            height='0.6rem'
          >
            <Text size='large' weight={400} color='shark'>
              {slackCommandBulletTitleText()}
              <br />
              <Text
                size='large'
                weight={400}
                lineHeight='2.4rem'
                color='shuttleGray'
              >
                {slackCommandBulletContentText()}
              </Text>
            </Text>
          </Bullet>

          <Text
            size='large'
            weight={400}
            lineHeight='2.4rem'
            color='chambray'
            mt='1rem'
            cursor='pointer'
            onClick={() =>
              LighthouseService.navigateArticle(ARTICLE_IDS.NOTIFICATION_TYPES)
            }
          >
            {learnMoreText()}
          </Text>
        </Flex>
      </Padding>
    </Flex>
  );
};

const ReAuthorizeInformationToolTip = ({ children }) => {
  return (
    <Tooltip title={tooltipContent()} placement='bottom-start' interactive>
      {children}
    </Tooltip>
  );
};

export default ReAuthorizeInformationToolTip;
